module.exports = __webpack_public_path__ + "120c52ed00e61c10a538b35b498020e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1.jpg
// module id = 217
// module chunks = 0